module.exports = __webpack_public_path__ + "img/tu08.539fb58f.jpg";